const NAMESPACES = {
  AWS: 'aws',
  LAMBDA: 'dashbird/lambda',
  APPSYNC_REQUESTS: 'dashbird/appsync/requests',
  APPSYNC_RESOLVERS: 'dashbird/appsync/resolvers'
}

export default NAMESPACES
